import * as storage from '../../util/storage';

export function toApiDateFormat(date: Date): string {
	return date.toISOString().substr(0, 10)
}

export const getAccessToken = () => {
  return localStorage.getItem(storage.KEY_ACCESS_TOKEN);
};

export const getRefreshToken = () => {
  return localStorage.getItem(storage.KEY_REFRESH_TOKEN);
};

export function getBaseHeader(json: boolean = false): Headers {
  const baseHeaders = {} as Headers
  baseHeaders["Authorization"] = 'Bearer ' + getAccessToken()

  if (json) baseHeaders["Content-Type"] = "application/json"

  return baseHeaders
};


// WEBPACK FOOTER //
// ./src/service/sfp/utils.ts